const initialState = () => ({
    snackbar: {
        timeout: 3000,
        color: '',
        show: false,
        text: ''
    },
    fromPrm:false
});

const getters = {
    snackbar: state => state.snackbar,
};

const actions = {
    resetState({ commit }) {
        commit('resetState')
    }
};

const mutations = {
    setSnackbar(state, snackbar) {
        state.snackbar = snackbar
    },
    // eslint-disable-next-line no-unused-vars
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    showError(state,text){
        state.snackbar = {
            timeout: 6000,
            color: "red darken-3",
            show: true,
            text:text
        };
    },
    showSuccess(state, text) {
        state.snackbar = {
            timeout: 6000,
            color: "green darken-3",
            show: true,
            text
        }
    },
    setFromPrm(state, val) {
        state.fromPrm = val;
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
